import Vue from "vue";
import Vuex from "vuex";
import user from "./modules/user.js";
import student from "./modules/student.js";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    namespaced: true,
    user,
    student,
  },
});
